import { NoticeWizard } from "components/page-components/Ausschreibungsdienste/notice-wizard"
import React from "react"
import { ArticleContentComponentContainer } from "../utils"

export const ArticleNoticeWizard = () => {
  return (
    <ArticleContentComponentContainer
      {...{
        custom_classes: "px-3 mt-6",
        attributes: { "data-nosnippet": true },
      }}
    >
      <NoticeWizard {...{ in_bfz_article: true }} />
    </ArticleContentComponentContainer>
  )
}
